import React from 'react';
import TopNavbar from '../Component/admin/TopNavbar';
import Sidebar from '../Component/admin/Sidebar';
import { Outlet } from 'react-router-dom';  // Import the Outlet component

import '../Assets/Css/admin_style.css';

const AdminLayout = () => {
  return (
    <div className="app-container">
      <TopNavbar />
      <div className="content-container">
        <Sidebar />
        <div className="main-content">
          <Outlet /> {/* This is where the child routes will be rendered */}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
